"use client"
/* */
import { useContext } from 'react';
import { listContext } from '../listContext.mjs';

const useList = () => useContext(listContext).list;

export { useList };
//# sourceMappingURL=useList.mjs.map
